import { render, staticRenderFns } from "./BookingFlow.vue?vue&type=template&id=b1a2ada0"
import script from "./BookingFlow.vue?vue&type=script&lang=js"
export * from "./BookingFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports